

import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'
import { Action, Getter } from 'vuex-class'
import CatalogManagementDto from '@/api/dto/CatalogManagementDto'

@Component({
    components: { BaseLayout },
    mixins: [StorageMixin]
})

export default class CatalogManagement extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('catalogManagementMapping')
    catalogManagementMapping!: CatalogManagementDto

    @Action('loadCatalogManagementMapping')
    loadCatalogManagementMapping!: () => Promise<void>

    @Action('saveCatalogManagementMapping')
    saveCatalogManagementMapping!: (mapping: CatalogManagementDto) => Promise<void>

    private errors: { [key: string]: string } = {}

    private loadAnimate = this.STATE.DEFAULT

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadCatalogManagementMapping()
        })
    }

    async save (): Promise <void> {
        if (!Object.keys(this.errors).length) {
            this.loadAnimate = this.STATE.LOADING

            await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
                await this.saveCatalogManagementMapping(this.catalogManagementMapping)
            }, this.$t('catalogManagement.success').toString())

            this.loadAnimate = this.STATE.DEFAULT
        }
    }
}
